import React from "react";

/**
 * SectionLabel renders a bracketed monospace label like:
 *   [ EXPERIENCE ]    or    > PROJECTS
 *
 * @param {{ index?: string, label: string, prompt?: boolean, testId?: string }} props
 */
export const SectionLabel = ({ index, label, prompt = false, testId }) => {
  return (
    <div
      data-testid={testId}
      className="flex items-center gap-3 font-mono text-xs tracking-widest text-ink-secondary"
    >
      {index && (
        <span className="text-ink-dim" aria-hidden="true">
          {index}
        </span>
      )}
      {prompt ? (
        <span className="text-accent">&gt;</span>
      ) : (
        <span className="text-accent">[</span>
      )}
      <span className="uppercase text-ink-primary">{label}</span>
      {!prompt && <span className="text-accent">]</span>}
      <span className="ml-2 h-px flex-1 bg-line" />
    </div>
  );
};

export default SectionLabel;
